import React from "react";
import { apiPut } from "../../utils/apiFetch";
import apiPath from "../../utils/apiPath";
import { isEmpty } from "lodash";
import dayjs from "dayjs";
import useToastContext from "hooks/useToastContext";
import { AiFillEdit } from "react-icons/ai";
import { useTranslation } from "react-i18next";
import { BsArrowUpShort } from "react-icons/bs";

import helper from "../../utils/helpers";
import TableHeaderCell from "components/reusable/TableHeaderCell";

const Table = ({ allBanner, user, sort, getBanner, handelEdit, setSort, manager }) => {
  const { t } = useTranslation();
  const notification = useToastContext();

  const handelStatusChange = async (item) => {
    try {
      const payload = {
        status: item?.status === "inactive" ? "active" : "inactive",
      };
      const path = `${apiPath.changeBannerStatus}/${item?._id}`;
      const result = await apiPut(path, payload);
      if (result?.status === 200) {
        notification.success(result.data.message);
        getBanner();
      }
    } catch (error) {
      console.log("error in get all banner list==>>>>", error.message);
    }
  };

  return (
    <div className="p-3">
      <div className="overflow-x-auto relative rounded-lg border">
        <table className="text-left text-[#6c6c6c] w-full text-xs dark:text-gray-400 ">
          <thead className="text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] text-xs dark:bg-gray-700 dark:text-gray-400">
            <tr>
              <TableHeaderCell text={t("SR_NO")} />
              <TableHeaderCell text={t("TITLE")} />
              <TableHeaderCell text={t("BANNER_IMAGE")} />
              <th
                scope="col"
                className="py-3 cursor-pointer px-6 "
                onClick={() => {
                  const newSortType = sort.sortType === "asc" ? "desc" : "asc";
                  setSort({
                    sortType: newSortType,
                    sortBy: "createdAt",
                  });
                }}
              >
                <div className="flex justify-start">
                  <span>{t("CREATED_DATE")}</span>
                  <span>{sort.sortBy === "createdAt" && <BsArrowUpShort className={`h-4 w-4  ${sort.sortType === "asc" ? "" : "rotate-180"}`} />}</span>
                </div>
              </th>

              <th scope="col" className="px-6 text-center py-3">
                {t("O_STATUS")}
              </th>
              {(manager?.edit || user?.role === "admin") && (
                <th scope="col" className="text-center py-3 px-6">
                  {t("O_ACTION")}
                </th>
              )}
            </tr>
          </thead>
          <tbody>
            {allBanner?.allBanners &&
              allBanner?.allBanners?.map((item, i) => (
                <tr key={i} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                  <th scope="row" className="py-4 px-6 border-r font-medium text-gray-900  dark:text-white">
                    {i + 1}
                  </th>
                  <td className="py-4 px-6 border-r text-gray-900">{item?.title}</td>
                  <td className="py-4 px-6 border-r text-gray-900">
                    <div className="flex">
                      <img className="w-10 h-10 rounded-full" src={item?.bannerImage ? item?.bannerImage : "images/default-product.jpg"} alt="" />
                    </div>
                  </td>
                  <td className="py-4 px-6 border-r text-gray-900">{dayjs(item?.createdAt).format("MM-DD-YYYY hh:mm A")} </td>

                  <td className="py-4 px-6 text-gray-900 border-r text-center">
                    <label className="inline-flex relative items-center cursor-pointer" title={`${item?.status === "active" ? "Active" : "Inactive"}`}>
                      <input
                        type="checkbox"
                        onChange={(e) => helper.alertFunction(`Are you sure you want to ${e.target.checked ? "active" : "inactive"} "${item.title} "?`, item, handelStatusChange)}
                        className="sr-only peer"
                        checked={item?.status === "active"}
                      />
                      <div className="bg-gray-200 rounded-full peer w-10 h-5 peer-focus:ring-0 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-LightBlue" />
                    </label>
                  </td>
                  {(manager?.edit || user?.role === "admin") && (
                    <td className="py-4 px-6 border-l text-gray-900">
                      <div className="">
                        <ul className="flex justify-center">
                          <li onClick={() => handelEdit(item)} className="px-2 py-2 hover:bg-white hover:text-LightBlue">
                            <a title={t("EDIT_BANNER")} className="hover:text-blue-700 transition duration-150 ease-in-out" data-bs-toggle="tooltip">
                              {" "}
                              <AiFillEdit className="cursor-pointer w-5 h-5 text-slate-600" />
                            </a>
                          </li>
                        </ul>
                      </div>
                    </td>
                  )}
                </tr>
              ))}
            {isEmpty(allBanner?.allBanners) ? (
              <tr className="bg-white text-center border-b dark:bg-gray-800 dark:border-gray-700">
                <td className="py-4 px-6 border-r" colSpan={12}>
                  {t("O_NO_RECORD_FOUND")}
                </td>
              </tr>
            ) : null}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Table;
